var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('main',[(!_vm.isPageNotFound)?_c('router-view',{attrs:{"name":"mainContent"}}):_c('div',{staticClass:"page_not_found"},[_c('h1',{staticClass:"page_not_found-heading_text"},[_vm._v(" 404 ")]),_c('router-link',{staticClass:"page_not_found-back_to_home",attrs:{"to":"/"}},[_vm._v(" Back to home page ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }